const SENSITIVE_KEY_PATTERN = /^(authorization|authorizationtoken|token|password|secret|cookie|api[-_]?key|otp|code)$/i

export const redactSensitiveData = (value, seen = new WeakSet()) => {
  if (value == null || typeof value !== 'object') return value
  if (seen.has(value)) return '[Circular]'

  seen.add(value)
  if (Array.isArray(value)) {
    return value.map((item) => redactSensitiveData(item, seen))
  }

  return Object.entries(value).reduce((safe, [key, item]) => {
    safe[key] = SENSITIVE_KEY_PATTERN.test(key)
      ? '[REDACTED]'
      : redactSensitiveData(item, seen)
    return safe
  }, {})
}

const getCurrentUserId = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}')?.id
  } catch (_) {
    return undefined
  }
}

const monitoringEnabled = () =>
  process.env.REACT_APP_SENTRY_ENABLED === 'true' &&
  Boolean(process.env.REACT_APP_SENTRY_DSN)

export const initializeErrorMonitoring = () => {
  try {
    if (!monitoringEnabled()) return
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.REACT_APP_APP_ENV || process.env.NODE_ENV,
    })
  } catch (_) {
    // Monitoring must never prevent the application from starting.
  }
}

export const captureError = (error, context = {}) => {
  try {
    const safeContext = redactSensitiveData({
      route: window.location.pathname,
      userId: getCurrentUserId(),
      ...context,
    })

    if (process.env.NODE_ENV !== 'production') {
      console.error('UI error', { error, context: safeContext })
    }

    if (!monitoringEnabled()) return undefined

    return Sentry.captureException(error, { extra: safeContext })
  } catch (_) {
    return undefined
  }
}

export const captureApiError = (error, context = {}) => {
  const metadata = error?.apiError || {}
  const safeError = new Error(metadata.message || 'API request failed')
  return captureError(safeError, {
    type: 'api_error',
    method: metadata.method,
    path: metadata.path,
    status: metadata.status,
    backendCode: metadata.code,
    requestId: metadata.requestId,
    correlationId: metadata.correlationId,
    frontendCorrelationId: metadata.frontendCorrelationId,
    ...context,
  })
}
import * as Sentry from '@sentry/react'
